<div class="box box--recommended">
  <div class="headline-wrap">
    <div class="headline headline--recommended">
      <h3 class="headline__title">
        POLECANE
      </h3>
<!--      <span class="headline__btn">usuń wszystko</span>-->
    </div>
  </div>
  <ul class="recommended-list text-uppercase">
    <li class="recommended-list__item" [attr.data-adobe]="'content:used:recomended:' + getModelFromFilters(item.filters)" [ngClass]="{'is-active': isActive(item)}" *ngFor="let item of data" (click)="updateEvent($event, item)">
      <span class="recommended-list__link">{{item.title}}</span>
      <span class="btn-delete" (click)="updateEvent($event, null)"><span class="icon-x"></span></span>
    </li>
  </ul>
</div>
